import { render, staticRenderFns } from "./LevyCalculationPanelReturnOnAssets.vue?vue&type=template&id=5cb10be0&"
import script from "./LevyCalculationPanelReturnOnAssets.vue?vue&type=script&lang=js&"
export * from "./LevyCalculationPanelReturnOnAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports